import { camo } from './camo';
import { euro } from './euro';
import { legends } from './legends';
import { modern } from './modern';
import { patriotic } from './patriotic';

export const soccer = {
  modern,
  euro,
  legends,
  patriotic,
  camo,
};
